import shower from 'assets/img/shower.png';
import clear from 'assets/img/Clear.png';
import hail from 'assets/img/Hail.png';
import heavyCloud from 'assets/img/HeavyCloud.png';
import heavyRain from 'assets/img/HeavyRain.png';
import lightCloud from 'assets/img/LightCloud.png';
import lightRain from 'assets/img/LightRain.png';
import sleet from 'assets/img/Sleet.png';
import snow from 'assets/img/Snow.png';
import thunderstrom from 'assets/img/Thunderstorm.png';

const IMG_WEATHER = {
  s: shower,
  c: clear,
  h: hail,
  hc: heavyCloud,
  hr: heavyRain,
  lc: lightCloud,
  lr: lightRain,
  sl: sleet,
  sn: snow,
  t: thunderstrom
};

export default IMG_WEATHER;

